import PropTypes from 'prop-types';
import cx from 'classnames';

/**
 *
 * @author Alexander Bunin <al.bunin@rambler-co.ru>
 */

export default function SmartArrow({ icon: Arrow, direction, ...restProps }) {
  return (
    <div className={cx('smartArrow', `_${direction}`)} {...restProps}>
      <style jsx>{`
        .smartArrow
          display inline-block
          &._down
            transform rotate(180deg)
          &._right
            transform rotate(90deg)
          &._left
            transform rotate(270deg)
          svg
            display block
      `}</style>

      <Arrow />
    </div>
  );
}

SmartArrow.propTypes = {
  /** Компонент иконки */
  icon: PropTypes.func.isRequired,
  /** Параметр, определяющий направление иконки */
  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
};

SmartArrow.defaultProps = {
  direction: 'up',
};
